<template>
    <div class="mt-4 col-lg-4">
        <div class="card bg-light">
            <div
                v-if="title.length>0"
                class="card-header d-flex justify-content-between align-items-center"
            >
                <h2 class="text-blurikorda mb-0">{{title}}</h2>
                <a
                    href="javascript:void(0)"
                    @click="goToViewAll"
                >{{viewAll}}</a>
            </div>

            <slot></slot>
            <!--vue-custom-scrollbar>
              <div class="card-body bg-white px-4">
                <slot></slot>
              </div>
            </vue-custom-scrollbar-->
        </div>
    </div>
</template>

<script>
//import vueCustomScrollbar from "vue-custom-scrollbar";
export default {
    name: "BackendDashboardBox",
    //components: { vueCustomScrollbar },
    props: ["title", "viewAll"],
    data() {
        return {};
    },

    methods: {
        goToViewAll() {
            this.$emit("viewAllClicked");
        }
    }
};
</script>

<style>
</style>
